/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Only_Networks_With_History_AllInputs */

const fr_settings_only_networks_with_history_all = /** @type {(inputs: Settings_Only_Networks_With_History_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les réseaux`)
};

const en_settings_only_networks_with_history_all = /** @type {(inputs: Settings_Only_Networks_With_History_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All networks`)
};

/**
* | output |
* | --- |
* | "All networks" |
*
* @param {Settings_Only_Networks_With_History_AllInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_only_networks_with_history_all = /** @type {((inputs?: Settings_Only_Networks_With_History_AllInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Only_Networks_With_History_AllInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_only_networks_with_history_all(inputs)
	return en_settings_only_networks_with_history_all(inputs)
});